import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../hooks/use-is-mobile";
import { useQueryParam } from "../../hooks/use-query-string";
import Footer from "./footer";
import { SubscribeHeader } from "./header";
import PlanBenifitsComponent from "./plan-benifits";
import PlanHeaderText from "./plan-header-text";
import { useInitiatePayment, useSubscriptionPlans } from "./queries";
import "./styles.scss";
import SubscribeSkeletonLoader from "./subscribe-skeleton-loader";
import SubscriptionPlanComponent from "./subscription-plan";
import { SubscriptionPlan } from "./types";
import { mixpanelTrack } from "../../utils/mixpanel-utils";

export function Subscribe() {
    const uuid = useQueryParam("uuid", "");
    const tz = useQueryParam("timezone", "Central");
    const { t } = useTranslation();
    const isMobile = useIsMobile();
    const { data: subscriptionPlans, isLoading: plansLoading } =
        useSubscriptionPlans(uuid, tz);
    const { mutateAsync, isLoading } = useInitiatePayment();
    const [selectedPlan, setSelectedPlan] = useState<SubscriptionPlan | null>();
    const handleContinuePayment = () => {
        if (selectedPlan) {
            void mutateAsync({
                productId: selectedPlan.stripe_product_id,
                provider: "stripe",
            });
        }
    };

    useEffect(() => {
        if (subscriptionPlans && subscriptionPlans.length > 0) {
            setSelectedPlan(subscriptionPlans[0]);
        }
    }, [subscriptionPlans]);

    useEffect(() => {
        mixpanelTrack("Subscription Page Viewed", {
            step: "Subscription",
            flow: "External Subscription",
        });
    }, []);

    if (plansLoading) {
        return <SubscribeSkeletonLoader />;
    }

    return (
        <>
            {!isMobile && <SubscribeHeader />}
            <div className="payment-wrapper">
                {isMobile && <SubscribeHeader />}
                <Col className="payment-plan-container">
                    <PlanHeaderText />
                    <Row className="plan-container">
                        {subscriptionPlans &&
                            subscriptionPlans.length === 0 && (
                                <div className="no-plans-text ml-4">
                                    {t("subscriptions.no_plan_included")}
                                </div>
                            )}
                        {selectedPlan &&
                        selectedPlan.features &&
                        selectedPlan.features.length > 0 ? (
                            <PlanBenifitsComponent
                                benifits={selectedPlan.features}
                            />
                        ) : (
                            <div className="benifits-section" />
                        )}
                        <SubscriptionPlanComponent
                            onPlanChange={(data: SubscriptionPlan) =>
                                setSelectedPlan(data)
                            }
                            subscriptionPlans={subscriptionPlans || []}
                        />
                    </Row>
                </Col>
                {selectedPlan && (
                    <Footer
                        plan={selectedPlan}
                        onSubscribe={handleContinuePayment}
                        isLoading={isLoading}
                    />
                )}
            </div>
        </>
    );
}
